import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Hero() {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* 背景图片 */}
      <div className="absolute inset-0 z-0">
        <div className="w-full h-full object-cover">
          <img 
            src="https://public.readdy.ai/ai/img_res/b4c082f17453e34e56b2cf89889355a6.jpg"
            alt="智慧港航背景"
            className="w-full h-full object-cover"
          />
        </div>
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60"></div>
      </div>

      {/* 导航栏 */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'}`}>
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="https://static.readdy.ai/image/a68e6275e3edc3dffa3b1dce13502b4a/e4c5d2d87fb7ab856d386f6e17f08b6c.png" alt="Logo" className="h-10 w-10" />
            <span className={`text-xl font-bold transition-colors ${scrolled ? 'text-gray-900' : 'text-white'}`}>智创灵眸</span>
          </div>
          <div className="hidden md:flex items-center gap-8">
            <a href="#features" className={`text-sm font-medium transition-colors hover:text-teal-500 ${scrolled ? 'text-gray-700' : 'text-white'}`}>核心功能</a>
            <a href="#architecture" className={`text-sm font-medium transition-colors hover:text-teal-500 ${scrolled ? 'text-gray-700' : 'text-white'}`}>技术架构</a>
            <a href="#scenarios" className={`text-sm font-medium transition-colors hover:text-teal-500 ${scrolled ? 'text-gray-700' : 'text-white'}`}>应用场景</a>
            <a href="#dashboard" className={`text-sm font-medium transition-colors hover:text-teal-500 ${scrolled ? 'text-gray-700' : 'text-white'}`}>数据驾驶舱</a>
            <button 
              onClick={() => navigate('/login')}
              className="px-6 py-2 bg-teal-500 text-white text-sm font-medium rounded-full hover:bg-teal-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              登录平台
            </button>
          </div>
        </div>
      </nav>

      {/* 主内容 */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 text-center">
        <div className="mb-8">
          <h1 className="text-7xl md:text-8xl font-black text-white mb-4 tracking-tight" style={{ textShadow: '0 0 30px rgba(20, 184, 166, 0.5)' }}>
            海陆空天
          </h1>
          <h2 className="text-4xl md:text-6xl font-light text-white/90 mb-3">
            一体化智能感知网络
          </h2>
          <p className="text-lg md:text-xl text-teal-400 tracking-widest font-light">
            SMART PORT UAV PLATFORM
          </p>
        </div>

        {/* 实时数据 */}
        <div className="flex justify-center gap-12 mb-12">
          <div className="text-center">
            <div className="text-4xl font-bold text-teal-400 mb-1">24</div>
            <div className="text-sm text-white/70">在线无人机</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-teal-400 mb-1">1,847</div>
            <div className="text-sm text-white/70">今日巡检里程(km)</div>
          </div>
          <div className="text-center">
            <div className="text-4xl font-bold text-teal-400 mb-1">3</div>
            <div className="text-sm text-white/70">预警事件</div>
          </div>
        </div>

        {/* CTA按钮 */}
        <div className="flex justify-center gap-4 mb-16">
          <button className="px-8 py-4 bg-teal-500 text-white font-medium rounded-lg hover:bg-teal-600 transition-all hover:shadow-lg hover:shadow-teal-500/50 flex items-center gap-2 cursor-pointer whitespace-nowrap">
            探索平台功能
            <i className="ri-arrow-right-line"></i>
          </button>
          <button className="px-8 py-4 border-2 border-teal-500 text-teal-400 font-medium rounded-lg hover:bg-teal-500/10 transition-all flex items-center gap-2 cursor-pointer whitespace-nowrap">
            <i className="ri-play-circle-line"></i>
            观看演示视频
          </button>
        </div>

        {/* 滚动提示 */}
        <div className="animate-bounce">
          <i className="ri-arrow-down-line text-3xl text-white/50"></i>
        </div>
      </div>
    </section>
  );
}